module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'hcrr0nr8',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
